import React from "react";
import withIntl from "../../utils/withIntl";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { Button, IconButton, MenuItem, Select, Typography } from "@material-ui/core";
import { Remove } from "@material-ui/icons";
import SelectElementDialog from "./SelectElementDialog";
import { useDialog } from "../Dialogs/DialogProvider";

const types = ["count", "print_name", "money_sign", "price", "article_name", "end_align", "custom_text"];

function PrintArticleLine(props) {
  const [articleLine, setArticleLine] = React.useState(props.articleLine);
  const [openDialog, closeDialog] = useDialog();

  const onDragEnd = (result) => {
    if (!result.destination) return;
    const items = articleLine.elements;
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    let newArticleLine = { ...articleLine };
    props.setArticleLine(newArticleLine);
    setArticleLine(newArticleLine);
  };

  return (
    <>
      <div style={{ display: "flex" }}>
        <Button
          variant={"outlined"}
          size={"small"}
          onClick={() => {
            props.onRemoveLine();
          }}
        >
          Remove Line
        </Button>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId={"droppable-print-article-line"} direction={"horizontal"}>
            {(provided) => {
              return (
                <div style={{ display: "flex" }} {...provided.droppableProps} ref={provided.innerRef}>
                  {articleLine.elements.map((line, index) => {
                    return (
                      <Draggable key={line} draggableId={"draggable-" + line} index={index}>
                        {(provided) => (
                          <div {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef}>
                            <div
                              style={{
                                borderRadius: 30,
                                border: "1px solid grey",
                                backgroundColor: "#EEE",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "0 4px",
                                margin: "0 4px",
                              }}
                            >
                              <Typography variant={"caption"} style={{ whiteSpace: "nowrap" }}>
                                {props.intl.messages["print_element_" + line]
                                  ? props.intl.formatMessage({ id: "print_element_" + line })
                                  : line}
                              </Typography>
                              <IconButton
                                size={"small"}
                                onClick={() => {
                                  articleLine.elements.splice(index, 1);
                                  let newArticleLine = { ...articleLine };
                                  setArticleLine(newArticleLine);
                                  props.setArticleLine(newArticleLine);
                                }}
                              >
                                <Remove />
                              </IconButton>
                            </div>
                          </div>
                        )}
                      </Draggable>
                    );
                  })}
                  {provided.placeholder}
                </div>
              );
            }}
          </Droppable>
        </DragDropContext>
        <Select
          value={articleLine.font_size}
          onChange={(e) => {
            articleLine.font_size = e.target.value;
            setArticleLine({ ...articleLine });
          }}
        >
          <MenuItem value={"medium"}>General font size</MenuItem>
          <MenuItem value={"large"}>Table number font size</MenuItem>
          <MenuItem value={"small"}>Custom font size 1</MenuItem>
          <MenuItem value={"huge"}>Custom font size 2</MenuItem>
        </Select>
        <Button
          variant={"outlined"}
          size={"small"}
          onClick={() => {
            openDialog({
              children: (
                <SelectElementDialog
                  onSelect={(selected) => {
                    articleLine.elements.push(selected);
                    let newArticleLine = { ...articleLine };
                    setArticleLine(newArticleLine);
                    props.setArticleLine(newArticleLine);
                    closeDialog();
                  }}
                />
              ),
            });
          }}
        >
          Add Element
        </Button>
      </div>
    </>
  );
}

export default withIntl(PrintArticleLine);
